import React from 'react';
import { GraduationCap } from 'lucide-react';
import './MentorsFaculty.css';

const mentors = [
  {
    name: 'Dr. Ayesha Khan',
    photo: 'https://randomuser.me/api/portraits/women/44.jpg',
    title: 'Senior Data Science Instructor',
    bio: '10+ years of experience in AI/ML. Ex-IBM researcher. Passionate educator.',
  },
  {
    name: 'Mr. Raj Mehta',
    photo: 'https://randomuser.me/api/portraits/men/46.jpg',
    title: 'Full Stack Web Developer',
    bio: 'React & Node.js expert with 7 years of industry experience. Loves teaching code!',
  },
  {
    name: 'Ms. Sneha Iyer',
    photo: 'https://randomuser.me/api/portraits/women/48.jpg',
    title: 'UI/UX & Design Mentor',
    bio: 'Design thinker and Figma pro. Ex-Adobe. Makes learning design intuitive.',
  },
];

const MentorsFaculty = () => {
  return (
    <section className="mentor-faculty-section">
      <div className="mentor-faculty-container">
        <div className="mentor-faculty-header">
          <GraduationCap className="mentor-faculty-icon" />
          <h2 className="mentor-faculty-title">Meet Our Mentors</h2>
          <p className="mentor-faculty-subtitle">
            Industry leaders guiding your learning journey with passion and precision.
          </p>
        </div>

        <div className="mentor-faculty-cards">
          {mentors.map((mentor, index) => (
            <div key={index} className="mentor-faculty-card">
              <div className="mentor-faculty-photo-box">
                <img
                  src={mentor.photo}
                  alt={mentor.name}
                  className="mentor-faculty-photo"
                />
              </div>
              <h3 className="mentor-faculty-name">{mentor.name}</h3>
              <p className="mentor-faculty-title-role">{mentor.title}</p>
              <p className="mentor-faculty-bio">{mentor.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MentorsFaculty;
